var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","left":"50%","top":"50%","tranform":"translate(-50%, -50%)"}},[_vm._v(_vm._s(_vm.$t('noPermission.txt1')))])
}
var staticRenderFns = []

export { render, staticRenderFns }